import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import styles from "./header.module.css"

function Header() {

    const [navOpen, setNavOpen] = useState(false);

    const toggleNavOpen = () => {
        setNavOpen(!navOpen);
    }

    return (
        <header className={`${styles.header} ${styles.headerHome}`}>

            <div className={styles.headerContent}>
                <Link to="/" className={styles.navNameLink}>
                    Kanami Nakabayashi
                </Link>

                <button onClick={toggleNavOpen} aria-label="Open navigation" className={styles.openNav}>&#9776;</button>
                <nav className={`${styles.nav} ${navOpen ? styles.navigationOpen : ""}`}>
                    <button onClick={toggleNavOpen} aria-label="Close navigation" className={styles.closeNav}>&times;</button>
                    <ul className={styles.navList}>
                        <li className={styles.navItem}><NavLink to="/" className={styles.navLink} activeClassName={styles.activePage}>Home</NavLink></li>
                        <li className={styles.dropdownButton}><NavLink to="/bio" className={styles.navLink} activeClassName={styles.activePage}>Bio</NavLink>
                            <ul className={styles.dropdown}>
                                <li className={styles.navLiHidden}><NavLink to="/teaching-experience" className={`${styles.navLink} ${styles.navLinkHidden}`} activeClassName={styles.activePage}>Teaching Experience</NavLink></li>
                            </ul>
                        </li>
                        <li className={styles.dropdownButton}><NavLink to="/performance" className={styles.navLink} activeClassName={styles.activePage}>Performance</NavLink>
                            <ul className={styles.dropdown}>
                                <li className={styles.navLiHidden}><NavLink to="/choreography" className={`${styles.navLink} ${styles.navLinkHidden}`} activeClassName={styles.activePage}>Choreography</NavLink></li>
                                <li className={styles.navLiHidden}><NavLink to="/commercial-works" className={`${styles.navLink} ${styles.navLinkHidden}`} activeClassName={styles.activePage}>Commercial Works</NavLink></li>
                            </ul>
                        </li>
                        <li className={styles.navItem}><NavLink to="/gallery" className={styles.navLink} activeClassName={styles.activePage}>Gallery</NavLink></li>
                        <li className={styles.navItem}><NavLink to="/contact" className={styles.navLink} activeClassName={styles.activePage}>Contact</NavLink></li>
                        <li className={styles.navItem}><a href="https://www.instagram.com/kanamdance/" className={styles.navLink} target="_blank" rel="noreferrer"><FontAwesomeIcon className={styles.instaIcon} icon={faInstagram} /></a></li>
                    </ul>
                </nav>
            </div>
        </header>

    );
}

export default Header;